import { createContext } from 'react';
/**
 * This context is used with a Modal component.
 * @example
 * const modal = useContext(ModalContext);
 */

var ModalContext = createContext({
  show: false,
  fluid: false,
  onClose: function onClose() {
    return {};
  }
});
export default ModalContext;